// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2E8KH","title":"ClientInsurance_title__3-b18","itemText":"ClientInsurance_itemText__2yclV"};